import { GiftItemResponse } from "../../api/v1/mypage/gift/owned/getResponse"
import { GIFT_TYPE_DEFINITIONS } from "./GIFT_TYPE_DEFINITIONS"
import { GiftItem } from "./GiftItem"
import { GiftType } from "./GiftType"

export const adaptGiftItem = (res: GiftItemResponse): GiftItem => {
  const giftType = GIFT_TYPE_DEFINITIONS.find(
    (v) => v.id === res.gift_item_id,
  ) as GiftType

  return {
    type: giftType,
    amount: res.amount,
  }
}
